import React from 'react';
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineTwitter,
} from 'react-icons/ai';
import { ContactUsForm } from './ContactUsForm';

export const Description = () => {
  return (
    <>
      <div className='px-4 py-12 mx-auto container w-12/12 bg-white items-center justify-center min-h-screen '>
      
            
           <ContactUsForm />
            
          
      </div>

    </>
  );
};
